/* Show the server-calculated saving for the selected native set option.
 * Does not calculate prices, select variants or mutate cart/app state.
 */
(() => {
  'use strict';
  const onVariant = event => {
    const id = String(event.detail?.variant?.id || '');
    if (!id) return;
    for (const root of document.querySelectorAll('[data-testid="set-savings"]')) {
      // A form control named "id" shadows HTMLFormElement.id in this theme.
      if (event.target.getAttribute?.('id') !== root.dataset.pciForm) continue;
      const panels = [...root.querySelectorAll('[data-pci-saving-variant]')];
      if (!panels.some(panel => panel.dataset.pciSavingVariant === id)) continue;
      for (const panel of panels) panel.hidden = panel.dataset.pciSavingVariant !== id;
      root.dataset.selectedVariant = id;
    }
  };
  document.addEventListener('variant:change', onVariant);
  window.addEventListener('pagehide', () => document.removeEventListener('variant:change', onVariant), {once: true});
  // Native touch scrolling; no drag interception, auto-advance or price/cart changes.
  for (const root of document.querySelectorAll('[data-testid="savings-sets"]')) {
    const slider = root.querySelector('[data-testid="savings-slider"]');
    const cards = slider ? [...slider.querySelectorAll('[data-testid="savings-card"]')] : [];
    const previous = root.querySelector('[data-pci-set-prev]');
    const next = root.querySelector('[data-pci-set-next]');
    const position = root.querySelector('[data-pci-set-position]');
    if (cards.length < 2 || !previous || !next || !position) continue;
    const mobile = matchMedia('(max-width: 699px)');
    let index = 0, scheduled = false;
    const update = () => {
      scheduled = false;
      const left = slider.getBoundingClientRect().left;
      index = cards.reduce((best, card, current) => Math.abs(card.getBoundingClientRect().left - left) < Math.abs(cards[best].getBoundingClientRect().left - left) ? current : best, 0);
      previous.disabled = index === 0;
      next.disabled = index === cards.length - 1;
      position.textContent = (index + 1) + ' von ' + cards.length;
      slider.tabIndex = mobile.matches ? 0 : -1;
    };
    const move = step => {
      const target = cards[Math.max(0, Math.min(cards.length - 1, index + step))];
      slider.scrollTo({left: slider.scrollLeft + target.getBoundingClientRect().left - slider.getBoundingClientRect().left, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
    };
    previous.addEventListener('click', () => move(-1));
    next.addEventListener('click', () => move(1));
    slider.addEventListener('scroll', () => { if (!scheduled) { scheduled = true; requestAnimationFrame(update); } }, {passive: true});
    slider.addEventListener('keydown', event => {
      if (event.target !== slider || !mobile.matches || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
      event.preventDefault(); move(event.key === 'ArrowRight' ? 1 : -1);
    });
    mobile.addEventListener('change', update);
    root.dataset.pciSwipeReady = 'true';
    update();
  }
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  if (reduced.matches || !('IntersectionObserver' in window)) return;
  const observer = new IntersectionObserver(entries => {
    for (const entry of entries) {
      if (!entry.isIntersecting) continue;
      entry.target.classList.add('is-lit');
      observer.unobserve(entry.target);
    }
  }, {threshold: .5});
  document.querySelectorAll('[data-pci-heat-accent], [data-pci-swipe-cue]').forEach(element => observer.observe(element));
  const stop = () => {
    observer.disconnect();
    document.querySelectorAll('[data-pci-heat-accent], [data-pci-swipe-cue]').forEach(element => element.classList.remove('is-lit'));
  };
  reduced.addEventListener('change', event => { if (event.matches) stop(); });
  window.addEventListener('pagehide', stop, {once: true});
})();
